import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { layoutAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { isLoading, load } from '../reducers/vidiprinter';
import FootballVidiprinter from '../components/FootballVidiprinter';
import CaretLink from 'modules/Common/components/CaretLink';

const REFRESH_INTERVAL_MILLIS = 10000;
const VIDIPRINTER_LINES = 5;

@layoutAsyncConnect(
  'FootballLiveHomeVidiprinterContainer',
  [{
    dispatch: () => load(VIDIPRINTER_LINES),
    preventResolve: ({state}) => isLoading(state),
    refreshInterval: REFRESH_INTERVAL_MILLIS,
    state: state => {
      let {football: {vidiprinter = {items: []}}} = state;
      return {vidiprinter};
    }
  }]
)
@catchLifeCycleErrors
export default class FootballLiveHomeVidiprinterContainer extends Component {
  static propTypes = {
    vidiprinter: PropTypes.object
  };

  render() {
    const {
      items: {
        lines = []
      } = {}
    } = this.props.vidiprinter;

    const limitedVidiprinterItems = {
      lines: lines.slice(0, VIDIPRINTER_LINES)
    };

    return (
      <div className="footballLiveHomeVidiPrinter">
        <h3 className="section-title">Vidiprinter</h3>
        <FootballVidiprinter data={limitedVidiprinterItems}/>
        <div><CaretLink to="/football/live/vidiprinter">See Full Vidiprinter</CaretLink></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Football/containers/FootballLiveHomeVidiprinterContainer.js